var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.value
    ? _c(
        "SoliChoice",
        {
          attrs: {
            bottom: _vm.$vuetify.breakpoint.xs,
            textOnly: "",
            backButton: "",
            title: _vm.teacher.name,
            fullscreen: "",
          },
          on: {
            reset: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          [
            _c(
              "div",
              { staticClass: "flex" },
              [
                _c(
                  "v-list-item-avatar",
                  {
                    staticClass: "my-0 ml-3",
                    attrs: {
                      size:
                        _vm.$vuetify.breakpoint.width < 350
                          ? 64
                          : _vm.$vuetify.breakpoint.xs
                          ? 86
                          : 104,
                    },
                  },
                  [
                    _c("v-img", {
                      attrs: { src: _vm.teacher.profile_photo_url },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex-col align-self-center" },
                  [
                    _c(
                      "v-list-item-subtitle",
                      {
                        staticClass: "font-bold soli-grey",
                        staticStyle: { "white-space": "normal" },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              `${
                                _vm.teacher.pronouns
                                  ? _vm.teacher.pronouns + " | "
                                  : ""
                              }${
                                _vm.teacher.instruments.length > 3
                                  ? _vm.teacher.instruments
                                      .filter((e, idx) => 3 > idx)
                                      .map((i) => " " + i.name) + "..."
                                  : _vm.teacher.instruments.map(
                                      (i) => " " + i.name
                                    )
                              }`
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    [
                      _vm.teacher.certification_level
                        ? _c("SoliTeacherCert", {
                            attrs: { teacher: _vm.teacher },
                          })
                        : _vm._e(),
                    ],
                    _vm._v(" "),
                    _vm.selectedInstrument
                      ? _c(
                          "v-list-item-subtitle",
                          {
                            staticClass: "flex align-center mr-1 flex-wrap",
                            staticStyle: { "line-height": "19px" },
                          },
                          [
                            _c(
                              "small",
                              { staticClass: "font-bold soli-grey mr-1" },
                              [_vm._v("Teaches:")]
                            ),
                            _vm._v(" "),
                            _vm._l(
                              [..._vm.ageRanges, ..._vm.skillLevels],
                              function (age) {
                                return _c(
                                  "v-chip",
                                  {
                                    key: age,
                                    attrs: {
                                      color: "secondary",
                                      "x-small": "",
                                    },
                                  },
                                  [_vm._v(_vm._s(`${age}`))]
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "px-3 pb-3",
                staticStyle: {
                  "overflow-y": "auto",
                  "white-space": "pre-line",
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.teacher.bio?.content) +
                    "\n        "
                ),
              ]
            ),
          ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }